<template>
  <div class="dashboard-page-cont dashboard-myrfq">
    <span class="model-title">生态订单概况</span>
    <ul class="myrfq-cont">
      <!-- 订单雷达 -->
      <li class="myrfq-item">
        <a class="myrfq-item-link" :href="linkList[0]" target="_blank">
          <div class="myrfq-item-icon icon-bg-2">
            <i class="iconfont icon-icon-kanban2"></i>
          </div>
          <div class="myrfq-item-b">
            <span class="myrfq-item-label">订单雷达</span>
            <span class="myrfq-item-value item-value-2">{{ canQuoteRfqNum }}</span>
          </div>
        </a>
      </li>
      <!-- 我的报价 -->
      <li class="myrfq-item">
        <a class="myrfq-item-link" :href="linkList[1]" target="_blank">
          <div class="myrfq-item-icon icon-bg-3">
            <i class="iconfont icon-icon-kanban3"></i>
          </div>
          <div class="myrfq-item-b">
            <span class="myrfq-item-label">我的报价</span>
            <span class="myrfq-item-value item-value-3">{{ totalQuoteNum }}</span>
          </div>
        </a>
      </li>
      <!-- 可转化客户 -->
      <!-- <li class="myrfq-item">
        <a class="myrfq-item-link" :href="linkList[2]" target="_blank">
          <div class="myrfq-item-icon icon-bg-3">
            <i class="iconfont icon-icon-kanban3"></i>
          </div>
          <div class="myrfq-item-b">
            <span class="myrfq-item-label">可转化客户</span>
            <span class="myrfq-item-value item-value-3">{{ canQuoteRfqNum }}</span>
          </div>
        </a>
      </li> -->
      <!-- 协议库 -->
      <li class="myrfq-item">
        <a class="myrfq-item-link" :href="linkList[3]" target="_blank">
          <div class="myrfq-item-icon icon-bg-4">
            <i class="iconfont icon-icon-baomixieyi"></i>
          </div>
          <div class="myrfq-item-b">
            <span class="myrfq-item-label">协议库</span>
            <span class="myrfq-item-value item-value-4">{{ agreementsNum }}</span>
          </div>
        </a>
      </li>
    </ul>

    <el-dialog
      custom-class="dialogClass"
      :visible.sync="dialogVisible"
      width="390px"
      :before-close="handleClose">
      <div>
        <p class='msg-one'>
          <i class="iconfont icon-icon-xinxijingshi"></i>
          <span>升级会员享有此服务</span>
        </p>
        <p class='msg-two'>如需帮助，请联系您的客服经理</p>
        <div class='msg-three'>
          <div>
            <p>{{$store.state.salesInfoData.userName}}</p>
            <p>客服经理</p>
          </div>
          <p class="msg-message">
            <i class="iconfont icon-icon-shoujihao"></i>
            <span>{{$store.state.salesInfoData.phone}}</span>
          </p>
          <p class="msg-message">
            <i class="iconfont icon-icon-zuojihao"></i>
            <span>{{$store.state.salesInfoData.tel}}</span>
          </p>
          <p class="msg-message">
            <i class="iconfont icon-icon-zuojihaobeifen"></i>
            <span style="color:#066EB7">{{$store.state.salesInfoData.email}}</span>
          </p>
        </div>
      </div>
    </el-dialog>
  </div>  
</template>

<script>
import { mapGetters, mapMutations,mapState } from "vuex";
import { zoologyNum } from '@/utils/api/dashboard';
import { presentUrl } from '@/utils/config';

export default {
  data() {
    return {
      presentUrl,
      linkList: [
        `${ presentUrl }/partner/order-radar`,  //订单雷达
        `${ presentUrl }/partner/quote`,  //我的报价
        `${ presentUrl }/partner/transformable-customer`, //可转化客户
        `${ presentUrl }/partner/agreement-repository`, //协议库
      ],
      agreementsNum: 0,
      canQuoteRfqNum: 0,
      totalQuoteNum: 0,
      dialogVisible: false
    }
  },
  methods: {
   
    // 关闭提示升级会员弹框
    handleClose(){
      this.dialogVisible = false;
    },
    // 获取数量
    getZoologyNum() {
      zoologyNum()
        .then(res=> {
            if(res.rspResult.bizCode == 200) {
              this.agreementsNum = res.data.agreementsNum || 0;  // 协议数量
              this.canQuoteRfqNum = res.data.canQuoteRfqNum || 0;  // 可报价询盘数量	
              this.totalQuoteNum = res.data.totalQuoteNum || 0;  // 总报价数量
            }
          })
          .catch(err=> {
            console.error('获取匹配询盘、邀请报价、授盘待接受、生产进度、待评价 的气泡数量失败', err)
          })
    },
  },
  created() {
    this.getZoologyNum();
  }
}
</script>

<style lang="scss" scoped>
.dashboard-myrfq {
  background: #fff;
  padding: 20px 0px 4px 20px;
  .myrfq-cont {
    display: flex;
    flex-wrap: wrap;
    .myrfq-item {
      // width: 183px;
      width: calc((100% - 64px) / 4);
      // max-width: 220px;
      height: 82px;
      border-radius: 4px;
      margin-right: 16px;
      margin-bottom: 16px;
      &-link {
        height: 100%;
        box-sizing: border-box;
        display: block;
        padding: 14px 16px;
        background: #F5F7FA;
        &:hover {
          background: #F1F7FA;
        }
      }
      &-icon {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        text-align: center;
        color: #fff;
        margin-bottom: 8px;
        .iconfont {
          line-height: 24px;
          font-size: 12px;
          display: inline-block;
          &.icon-icon-kanban5 {
            margin-left: -1px;
          }
        }

      }
      &-b {
        display: flex;
        align-items: center;
        user-select: none;
        .myrfq-item-label {
          width: max-content;
          margin-right: 10px;
          flex-shrink: 0;
          height: 14px;
          line-height: 14px;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #16181A;
          letter-spacing: 0;
          text-align: justify;
        }
        .myrfq-item-value {
          flex: 1;
          height: 22px;
          font-family: Arial;
          font-weight: Bold;
          font-size: 20px;
          line-height: 22px;
          color: #318CED;
          letter-spacing: 0;
          text-align: right;
        }
      }
      &:nth-last-child(1) {
        margin-right: 0;
      }

      // 处理图标的背景和数量的颜色
      .icon-bg-1 {
        background-image: linear-gradient(155deg, #FF9046 0%, #FF6600 100%);
      }
      .item-value-1 {
        color: #FF7F2A;
      }
      .icon-bg-2 {
        background-image: linear-gradient(155deg, #8992FC 0%, #4956F1 100%);
      }
      .item-value-2 {
        color: #318CED;
      }
      .icon-bg-3 {
        background-image: linear-gradient(155deg, #D264FF 0%, #9B1DEB 100%);
      }
      .item-value-3 {
        color: #A024ED;
      }
      .icon-bg-4 {
        background-image: linear-gradient(155deg, #FF9046 0%, #FF6600 100%);
      }
      .item-value-4 {
        color: #FF7F2A;
      }
      .icon-bg-5 {
        background-image: linear-gradient(155deg, #5BDC5D 0%, #20B820 100%);
      }
      .item-value-5 {
        color: #20B820;
      }
      .icon-bg-6 {
        background-image: linear-gradient(155deg, #5FC0F7 0%, #318CED 100%);
      }
      .item-value-6 {
        color: #318CED;
      }
      .icon-bg-7 {
        background-image: linear-gradient(155deg, #59E5D3 0%, #48D2BE 100%);
      }
      .item-value-7 {
        color: #4BD5C1;
      }

    }
  }
}
::v-deep .dialogClass{
  .el-dialog__body{
    padding: 0 32px 30px;
  }
  .el-dialog__headerbtn{
    top: 31px;
    right: 32px;
  }
  .el-dialog__close{
      font-weight: 600;
  }
  div{
    text-align:center ;
    .msg-one{
      color:#FF6905;
      i{
        font-size: 16px; 
        margin-right: 5px;
      }
      span{
        font-size: 16px;
        font-family: SourceHanSansCN-Medium;
      }
    }
    .msg-two{
      margin:20px 0 20px;
      color: #4F5D78;
      font-family: SourceHanSansCN-Regular;
    }
    .msg-three{
      width: 268px;
      box-shadow: 0 0 6px 0 #066eb71a;
      border-radius: 2px;
      margin:0 auto;
      text-align: left;
      line-height:20px;
      padding:16px;
      background-image:url('~@/assets/image/common/upcard.jpg') ;
      div{
        p{
          text-align: left;
          color: #16181A;
        }
        p:first-child{
          font-weight: 600;
        }
        p:last-child{
          color:#4F5D78;
          font-size:12px;
          line-height: 16px;
          margin-bottom: 17px;
          font-family: SourceHanSansCN-Medium;
        }
      }
      .msg-message{
        line-height: 24px;
        i{
          color: #FF7F2A;
          margin-right:8px;
          font-size: 12px;
        }
        span{
          color: #16181A;
        }
      }

    }
  }
}
</style>